import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { DocumentDraftStatusTagsProps } from "models/propTypes/documentDraftPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
import { useDocumentDraftService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const DocumentDraftStatusTags: React.FC<DocumentDraftStatusTagsProps> = (props) => {
  const documentDraftService = useDocumentDraftService();
  const getLabelClass = (status: WintSuperkollAPIModel.DocumentDraftState) => {
    switch (status) {
      case WintSuperkollAPIModel.DocumentDraftState.Created:
        return cssExports.yellowTag;
      case WintSuperkollAPIModel.DocumentDraftState.Handled:
        return cssExports.greenTag;
      case WintSuperkollAPIModel.DocumentDraftState.Removed:
        return cssExports.redTag;
      case WintSuperkollAPIModel.DocumentDraftState.HandledByWint:
        return cssExports.blueTag;
      default:
        return cssExports.grayTag;
    }
  };
  return <Tags tags={[documentDraftService.getStateText(props.status)]} className={getLabelClass(props.status)} />;
};

export default DocumentDraftStatusTags;
